import { ClickNavigationProps } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { OrionContactSyncSettings } from './OrionContactSyncSettings'

export const OrionSpecificSettings = (): ClickNavigationProps[] => {
  return [{ id: 'contactSync', label: 'Contact Sync', content: () => <OrionContactSyncSettings /> }]
}
